import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";

import Icon from "../Icon";

import * as copyBlockStyles from "./CopyBlock.module.css";
import Button from "../Button";
import { richTextOptions } from "../../utils/richTextOptions";

const CopyBlock = ({ props, row, moduleBackgroundColor }) => {
  const {
    icon,
    centerAlignContent,
    textColor,
    headline,
    headlineLevel,
    enableHeadlineBottomBorder,
    copy,
    ctaButton,
    name,
  } = props;

  const HeadingTag = headline ? `${headlineLevel}` : "h6";
  const column = `row${row ? row : "3"}`;

  return (
    <div
      className={`${copyBlockStyles.copyBlock} ${copyBlockStyles[column]} ${
        copyBlockStyles[textColor]
      } ${centerAlignContent && copyBlockStyles.center} ${
        enableHeadlineBottomBorder && copyBlockStyles.enableHeadlineBottomBorder
      } ${
        moduleBackgroundColor
          ? copyBlockStyles[`moduleBackground${moduleBackgroundColor}`]
          : ""
      }`}
      // data-aos="fade-in"
    >
      {icon && <Icon props={icon} />}
      {headline && (
        <HeadingTag className={copyBlockStyles.headline}>{headline}</HeadingTag>
      )}
      {copy && <>{renderRichText(copy, richTextOptions)}</>}
      {ctaButton && (
        <div className={copyBlockStyles.ctaButton}>
          <Button {...ctaButton} name={name}>
            {ctaButton.title}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CopyBlock;
